module.exports = __webpack_public_path__ + "media/assets/site_images/partner_logos/base_forte_logo-e4547b701f93ca72edc7cce6b66e8bee.png";